import { inject, ref } from 'vue';
import { defaultCarAdvisoryAppConfig, GlobalProperties } from '../foundation/enums/GlobalProperties';
import { IConfiguration } from '../foundation/interfaces/IConfiguration';
import { IDatasource } from '../foundation/interfaces/IDatasource';
import { routeMappings } from '../foundation/routeMappings';
import { useConfigStore } from '../foundation/stores/configStore';
import * as ApiConstant from '../foundation/apiConstant';

export function useAppConfig() {
  // Inject datasource into App for passing to components.
  const datasource: IDatasource = inject(GlobalProperties.Datasource) as IDatasource;
  const componentDatasourceProps = datasource;

  const componentSpecified = ref(false);
  const componentPath = ref('views');

  // Inject configuration into the store based on data-props in root element
  const serverConfiguration: IConfiguration = inject(GlobalProperties.ServerConfiguration) as IConfiguration;
  const configStore = useConfigStore();
  configStore.setConfigState(ApiConstant.isProduction ? serverConfiguration : defaultCarAdvisoryAppConfig);

  // TODO: refactor componentPath calculation
  if (serverConfiguration?.ComponentName) {
    componentSpecified.value = true;
    componentPath.value = routeMappings[serverConfiguration?.ComponentName] ?? '';
  }

  return {
    componentPath,
    serverConfiguration,
    componentSpecified,
    componentDatasourceProps,
  };
}
